import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/home.css';

function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="eduss-home-page" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(120deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
      <h1 style={{ fontSize: '4rem', color: 'var(--eduss-primary-color)', marginBottom: 0 }}>404</h1>
      <h2 style={{ color: 'var(--eduss-text-dark)', marginTop: 0 }}>Page Not Found</h2>
      <p style={{ color: 'var(--eduss-text-muted)', marginBottom: '2em' }}>
        Sorry, the page you are looking for does not exist or has been moved.
      </p>
      <button className="eduss-home-cta" onClick={() => navigate('/')}>Go to Home</button>
    </div>
  );
}

export default NotFoundPage;